import React from 'react';
import clsx from 'clsx';

import scss from './PanelBody.module.scss';

function PanelBody({ className, children }) {
  return <div className={clsx(scss.body, className)}>{children}</div>;
}

export default PanelBody;
